import { Button } from '@ui/Button';
import { focusModeIconPaths } from 'hooks/usePreferences/customIcons';
import { type ButtonHTMLAttributes } from 'react';
import { Colors } from 'styles';

type FocusModeButtonProps = {
  isFocusModeOn: boolean;
  onClick: ButtonHTMLAttributes<HTMLButtonElement>['onClick'];
};

const FocusModeIcon = () => (
  <svg width="16" height="18" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    {focusModeIconPaths.map((d) => (
      <path key={d} d={d} fill="white" />
    ))}
  </svg>
);

const FOCUS_MODE_GRADIENT = [
  `linear-gradient(180deg, #ffffff33 0%, #ffffff00 34%, ${Colors.shadow}80 100%)`,
  `linear-gradient(90deg, ${Colors.darkBackground}33 0%, ${Colors.shadow}55 58%, ${Colors.shadow}22 100%)`,
  `linear-gradient(170deg, ${Colors.gradientStart} 0%, ${Colors.gradientEnd} 100%)`,
].join(', ');

const FOCUS_MODE_BOX_SHADOW = `inset 0 1px 2px #ffffff66, inset 0 -2px 4px ${Colors.shadow}99`;

export const FocusModeButton = ({ isFocusModeOn, onClick }: FocusModeButtonProps) => (
  <span className="relative inline-flex ml-2 group">
    <span
      aria-hidden
      className={`absolute inset-0 rounded-lg pointer-events-none transition-opacity duration-150${isFocusModeOn ? ' opacity-100 group-hover:opacity-85' : ' opacity-0'}`}
      style={{
        background: FOCUS_MODE_GRADIENT,
        boxShadow: isFocusModeOn ? FOCUS_MODE_BOX_SHADOW : undefined,
      }}
    />
    <Button
      type="button"
      onClick={onClick}
      aria-pressed={isFocusModeOn}
      data-testid="focus-mode-button"
      size="small"
      variant="secondary"
      iconLeading={<FocusModeIcon />}
      className={`[&_svg]:size-12 relative h-24 px-8${isFocusModeOn ? ' border-transparent text-white' : ''}`}
      style={
        isFocusModeOn ? { backgroundColor: 'transparent', borderColor: 'transparent' } : undefined
      }
    >
      Focus Mode
    </Button>
  </span>
);
